import { stringify } from 'query-string';
import { decamelizeKeys } from 'humps';
import { DataLocalStorage } from '@wkda/funnel-utils';
import { DSBAPICache, injectAPICache } from '@wkda/api-cache-client';
import { createAxiosClient } from '../axiosDefaults';

function getApiCache() {
  if (typeof window === 'undefined') {
    return {
      get: () => null,
      set: () => null
    };
  }

  return new DSBAPICache(new DataLocalStorage(), 'dsb_apis_cache');
}

export function createApi(baseUrl) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let config = arguments.length > 2 ? arguments[2] : undefined;
  const axiosInstance = createAxiosClient({
    baseURL: baseUrl + "/cardata/types",
    withCredentials: true,

    paramsSerializer(params) {
      return stringify(decamelizeKeys({ ...params,
        locale: config.fullLocale
      }, {
        separator: '-',

        process(key, convert, options) {
          // the only param which should not be dashrized is pageSize
          return key === 'pageSize' ? key : convert(key, options);
        }

      }));
    },

    ...axiosConfig
  }, config);
  const apiClient = injectAPICache(getApiCache(), axiosInstance);

  function getApiHandler(url) {
    return params => {
      const {
        builtDate,
        horsePower,
        ...otherParams
      } = params;
      const newParams = otherParams;

      if (builtDate) {
        newParams.builtYear = builtDate;
      }

      if (horsePower) {
        newParams.kw = horsePower;
      }

      return apiClient.get(url, {
        params: newParams
      }).then(r => {
        return r.data;
      });
    };
  }

  return {
    getManufacturers: getApiHandler('/manufacturers'),
    getMainTypes: getApiHandler('/main-types'),
    getBuiltDates: getApiHandler('/built-years'),
    getBodyTypes: getApiHandler('/body-types'),
    getMainTypesDetails: getApiHandler('/main-types-details'),
    getMainTypesSub: getApiHandler('/main-types-sub'),
    getSubtypeExtra: getApiHandler('/main-types-sub'),
    getFuelTypes: getApiHandler('/fuel-types'),
    getHorsePower: getApiHandler('/kw'),
    getGearTypes: getApiHandler('/gear-types'),
    getDoorCount: getApiHandler('/door-counts')
  };
}